var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSynchronize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.synchronize-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "synchronize-svg",
    d: "M7.2,0.8L4.8,3l2.5,2.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "synchronize-svg",
    d: "M8.8,15.2l2.5-2.2l-2.5-2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "synchronize-svg",
    d: "M5.8,3h3.5c3.3,0,6,2.7,6,6v0.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "synchronize-svg",
    d: "M10.2,13H6.8c-3.3,0-6-2.7-6-6V6.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronize);
export default __webpack_public_path__ + "static/media/synchronize.29477e09f255461cf5567bcc4e13b4b0.svg";
export { ForwardRef as ReactComponent };